import cx from 'classnames';
import { format } from 'date-fns';
import React from 'react';

import { PlusIcon, TrashIcon } from './Icons';
import { ASSISTANT_TEXTS } from '../../texts';

import styles from './styles.module.css';

const formatItemTime = (ts) => {
	if (!ts) return '';

	try {
		const date = new Date(ts);
		const today = new Date();
		const isToday = date.toDateString() === today.toDateString();

		return isToday ? format(date, 'HH:mm') : format(date, 'd MMM');
	} catch {
		return '';
	}
};

const ConversationSidebar = ({
	conversationGroups,
	activeId,
	onSelectConversation,
	onNewConversation,
	onDeleteConversation,
	onClearAllHistory,
}) => (
	<aside className={styles.sidebar}>
		<div className={styles.sidebarHeader}>
			<div className={styles.sidebarLabel}>{ASSISTANT_TEXTS.conversations}</div>
			<button className={styles.newChatBtn} type="button" onClick={onNewConversation}>
				<PlusIcon />
				{ASSISTANT_TEXTS.newConversation}
			</button>
		</div>

		<div className={styles.historyList}>
			{conversationGroups.map((group) => (
				<React.Fragment key={group.label}>
					<div className={styles.groupLabel}>{group.label}</div>
					{group.items.map((item) => (
						<div
							key={item.conversationId}
							className={cx(styles.historyItem, {
								[styles.historyItemActive]: item.conversationId === activeId,
							})}
							onClick={() => onSelectConversation(item.conversationId)}
							role="button"
							tabIndex={0}
							onKeyDown={(e) =>
								(e.key === 'Enter' || e.key === ' ') && onSelectConversation(item.conversationId)
							}
						>
							<div className={styles.itemBody}>
								<div className={styles.itemTitle}>{item.title}</div>
								<div className={styles.itemPreview}>{item.preview}</div>
								<div className={styles.itemTime}>{formatItemTime(item.lastMessageAt)}</div>
							</div>
							<button
								type="button"
								className={styles.deleteBtn}
								aria-label={ASSISTANT_TEXTS.deleteConversation}
								title={ASSISTANT_TEXTS.deleteConversation}
								onClick={(e) => {
									e.stopPropagation();
									onDeleteConversation?.(item.conversationId);
								}}
							>
								<TrashIcon />
							</button>
						</div>
					))}
				</React.Fragment>
			))}
		</div>

		{onClearAllHistory && (
			<div className={styles.sidebarFooter}>
				<button
					type="button"
					className={styles.clearAllBtn}
					onClick={onClearAllHistory}
					disabled={conversationGroups.length === 0}
				>
					{ASSISTANT_TEXTS.clearAllHistory}
				</button>
			</div>
		)}
	</aside>
);

export default ConversationSidebar;
